import React from 'react'
import styled from 'styled-components'
import media from '../styles/media'
import { FormattedMessage} from 'gatsby-plugin-intl'
import { pathPrefix } from '../../gatsby-config'
import logo from '../assets/images/logo-almesa-color.svg'
import 'bootstrap/dist/css/bootstrap.min.css'

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'

const Container = styled.div`
  margin: 15px;
  .logo-responsive{
    width: 300px;
    ${media.sm`
      width: 200px;
    `};
  }
  .navbar-light .navbar-toggler {
    border-color: #fff !important;
  }
  .navbar-toggler {
    font-size: 2.25rem !important;
  }
  .navbar-light .navbar-nav .nav-link {
    color: #404040;
  }
  .ml-auto {
    font-size: 18px;
  }
  ul li {
    list-style: none;
    padding: 10px;
  }

  .textBlack {
    color: #000;
    font-family: 'Prelo-Book';
    font-size: 16px;
  }
`

export default class Menu extends React.Component {
  constructor(props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = {
      isOpen: false
    }
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }
  render() {
    return (
      <Container>
        <Navbar color="white" light expand="md">
          <NavbarBrand href={pathPrefix}>
            <img src={logo} alt="" className="img-responsive logo-responsive" />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink href={pathPrefix}>
                  <FormattedMessage id="MenuInicio" />
                </NavLink>
              </NavItem>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                  <FormattedMessage id="MenuSomos" />
                </DropdownToggle>
                <DropdownMenu right>
                <DropdownItem className="textBlack" href={pathPrefix + "nosotros"}>
                    <FormattedMessage id="MenuNosotros" />
                  </DropdownItem>
                  <DropdownItem className="textBlack" href={pathPrefix + "gobierno-corporativo"}>
                    <FormattedMessage id="MenuGobierno" />
                  </DropdownItem>                 
                  <DropdownItem divider />
                  <DropdownItem className="textBlack" href={pathPrefix + "transparencia-informacion"}>
                    <FormattedMessage id="MenuTransparencia" />
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <NavItem>
                <NavLink href={pathPrefix + "servicios"}>
                  <FormattedMessage id="MenuServicios" />
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href={pathPrefix + "oficinas"}>
                  <FormattedMessage id="MenuOficina" />
                </NavLink>
              </NavItem>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                  <FormattedMessage id="MenuContactenos" />
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem className="textBlack" href={pathPrefix + "solicitud-servicios"}>
                    <FormattedMessage id="MenuSolicitud" />
                  </DropdownItem>
                  <DropdownItem className="textBlack" href={pathPrefix + "formulario-quejas"}>
                    <FormattedMessage id="MenuFormQuejas" />
                  </DropdownItem>
                  <DropdownItem className="textBlack" href={pathPrefix + "formulario-denuncias"}>
                    <FormattedMessage id="MenuFormDenuncias" />
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Navbar>
      </Container>
    )
  }
}
